/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";

class CheckboxLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
    };
  }
  componentDidMount() {
    // console.log(this.props.selectdata.disable,this.props.selectdata.parrentName,this.props.selectdata.value);
  }

  // componentDidUpdate(prevProps){
  //     console.log(prevProps.selectdata.value,this.props.selectdata.value,this.props.selectdata.parrentName, this.props.selectdata.name);
  // }

  onChange(evt) {
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    let { slug } = this.props.match.params;
    if (slug !== "view-role") {
      this.props.onselectChanges({
        name: this.props.selectdata.name,
        id: this.props.selectdata.name,
        value: evt.target.checked,
        parrentMode: this.props.selectdata.parrentMode,
        parrentName: this.props.selectdata.parrentName,
      });
    }
  }

  render() {
    return (
      <label>
        <input
          type="checkbox"
          checked={
            this.props.selectdata.value ? this.props.selectdata.value : false
          }
          name={this.props.selectdata.name}
          onChange={(evt) => this.onChange(evt)}
          disabled={this.props.selectdata.disable}
        />
        <span>{this.props.selectdata.label}</span>
      </label>
    );
  }
}

export default CheckboxLayer;
